import { Injectable } from '@angular/core';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  constructor(
    private http: HttpService
  ) { }

  atualizar(){
    
    const user = JSON.parse(localStorage.token)
    
    const datas = {
      email: user.email,
      password: 'Colloca!@#19812'
    }

    this.http.save('auth:login', datas)
    .subscribe(
      (result: any) => {        
        if (result.data) {
          let token = localStorage.setItem('token', JSON.stringify(result.data));
          return token;
        }
      }
    )

  }

}
